import config from '../config'
import GenericApiService from './generic-api-service'

const baseURL = config.urls.packs
const secondaryIndicesKeys = ['patientId', 'packId']

const packsService = new GenericApiService(baseURL, '_id', secondaryIndicesKeys)

export default packsService
